import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid1x3Vertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDotGrid1x3Vertical"><Path d="M11 2.5H13V4.5H11V2.5Z" fill="currentColor"/><Path d="M13 11H11V13H13V11Z" fill="currentColor"/><Path d="M11 19.5H13V21.5H11V19.5Z" fill="currentColor"/><Path d="M11 2.5H13V4.5H11V2.5Z" stroke="currentColor"/><Path d="M13 11H11V13H13V11Z" stroke="currentColor"/><Path d="M11 19.5H13V21.5H11V19.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3Vertical;
